import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, Output, } from '@angular/core';
import { ButtonPurpose } from '@mhe/ngx-shared/button';
import { Subject, forkJoin } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@mhe/ngx-shared/translate";
import * as i2 from "@angular/cdk/a11y";
import * as i3 from "@angular/common";
import * as i4 from "@mhe/ngx-shared/tooltip";
const _c0 = ["pagerMessage"];
function PagerComponent_ng_container_0_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c1 = function (a0) { return { $implicit: a0 }; };
function PagerComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PagerComponent_ng_container_0_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const page_r10 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, page_r10));
} }
function PagerComponent_ng_container_0_button_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "mheTranslate");
    i0.ɵɵtext(3, " \u22EF ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind1(2, 3, "ngx-shared-pager-ellipsis")));
} }
function PagerComponent_ng_container_0_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PagerComponent_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PagerComponent_ng_container_0_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const page_r12 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, page_r12));
} }
function PagerComponent_ng_container_0_button_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "mheTranslate");
    i0.ɵɵtext(3, " \u22EF ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind1(2, 3, "ngx-shared-pager-ellipsis")));
} }
function PagerComponent_ng_container_0_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PagerComponent_ng_container_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PagerComponent_ng_container_0_ng_container_8_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const page_r14 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, page_r14));
} }
function PagerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5)(2, "button", 6);
    i0.ɵɵlistener("click", function PagerComponent_ng_container_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.previousPage()); });
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PagerComponent_ng_container_0_ng_container_4_Template, 2, 4, "ng-container", 8);
    i0.ɵɵtemplate(5, PagerComponent_ng_container_0_button_5_Template, 4, 5, "button", 9);
    i0.ɵɵtemplate(6, PagerComponent_ng_container_0_ng_container_6_Template, 2, 4, "ng-container", 8);
    i0.ɵɵtemplate(7, PagerComponent_ng_container_0_button_7_Template, 4, 5, "button", 9);
    i0.ɵɵtemplate(8, PagerComponent_ng_container_0_ng_container_8_Template, 2, 4, "ng-container", 8);
    i0.ɵɵelementStart(9, "button", 10);
    i0.ɵɵlistener("click", function PagerComponent_ng_container_0_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.nextPage()); });
    i0.ɵɵelement(10, "i", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r0.previousButtonDisabled());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.getStartPages());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.shouldShowFirstElipsis());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.getMiddlePages());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.shouldShowLastElipsis());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.getEndPages());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r0.nextButtonDisabled());
} }
function PagerComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function PagerComponent_ng_template_3_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r21); const page_r19 = restoredCtx.$implicit; const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.goToPage(page_r19)); });
    i0.ɵɵelementStart(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "mheTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const page_r19 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("btn-light", ctx_r2.pageIndex !== page_r19)("btn-primary", ctx_r2.pageIndex === page_r19);
    i0.ɵɵproperty("disabled", ctx_r2.disabled);
    i0.ɵɵattribute("aria-current", ctx_r2.pageIndex === page_r19);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 8, i0.ɵɵpipeBind1(4, 10, "ngx-shared-page")));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", page_r19 + 1, " ");
} }
function PagerComponent_ng_template_5_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function PagerComponent_ng_template_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵi18n(1, 16);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "mheTranslate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pageItems_r22 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵi18nExp(pageItems_r22.first)(i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(3, 5, "ngx-shared-of")))(pageItems_r22.total);
    i0.ɵɵi18nApply(1);
} }
function PagerComponent_ng_template_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵi18nStart(1, 17);
    i0.ɵɵelement(2, "span", 15);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "mheTranslate");
    i0.ɵɵelement(5, "span", 18);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "mheTranslate");
    i0.ɵɵi18nEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pageItems_r22 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(7);
    i0.ɵɵi18nExp(pageItems_r22.first)(i0.ɵɵpipeBind1(3, 5, i0.ɵɵpipeBind1(4, 7, "ngx-shared-to")))(pageItems_r22.last)(i0.ɵɵpipeBind1(6, 9, i0.ɵɵpipeBind1(7, 11, "ngx-shared-of")))(pageItems_r22.total);
    i0.ɵɵi18nApply(1);
} }
function PagerComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PagerComponent_ng_template_5_span_0_Template, 1, 0, "span", 0);
    i0.ɵɵtemplate(1, PagerComponent_ng_template_5_span_1_Template, 4, 7, "span", 0);
    i0.ɵɵtemplate(2, PagerComponent_ng_template_5_span_2_Template, 8, 13, "span", 0);
} if (rf & 2) {
    const pageItems_r22 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", pageItems_r22.count === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", pageItems_r22.count === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", pageItems_r22.count > 1);
} }
const _c6 = function () { return { "word-spacing": "normal" }; };
export class PagerComponent {
    constructor(translateService, liveAnnouncer, renderer, el) {
        this.translateService = translateService;
        this.liveAnnouncer = liveAnnouncer;
        this.renderer = renderer;
        this.el = el;
        this.startPageCount = 1;
        this.middlePageCount = 5;
        this.endPageCount = 1;
        this.disabled = false;
        /** The zero-based page index of the displayed list of items. Defaulted to 0. */
        this.pageIndex = 0;
        /** The length of the total number of items that are being paginated. Defaulted to 0. */
        this.length = 0;
        /** Number of items to display on a page. By default set to 50. */
        this.pageSize = 50;
        this.page = new EventEmitter();
        /** These are internal-only members.  The getters allow the template access */
        this.startPages = [];
        this.middlePages = [];
        this.endPages = [];
        this.destroy$ = new Subject();
        this._buttonPurpose = ButtonPurpose;
        this.renderer.setAttribute(el.nativeElement, 'aria-label', 'page');
        this.renderer.setAttribute(el.nativeElement, 'role', 'navigation');
    }
    getStartPages() {
        return this.startPages;
    }
    getMiddlePages() {
        return this.middlePages;
    }
    getEndPages() {
        return this.endPages;
    }
    shouldShowFirstElipsis() {
        return (this.startPages.length > 0 && this.startPages[this.startPages.length - 1] + 1 < this.middlePages[0]);
    }
    shouldShowLastElipsis() {
        return this.endPages.length > 0 && this.middlePages[this.middlePages.length - 1] + 1 < this.endPages[0];
    }
    ngOnInit() {
        // Fire this initial event so the consuming app knows what items we're viewing
        this.updatePageNumbers();
        this.emitPageEvent(this.pageIndex);
        this.announcePage(this.pageIndex);
    }
    ngOnChanges() {
        this.updatePageNumbers();
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }
    updatePageNumbers() {
        const totalPages = this.getNumberOfPages();
        const lastPageIndex = totalPages - 1;
        const maxPageIndexFilter = (i) => i <= lastPageIndex;
        if (this.pageIndex > lastPageIndex) {
            this.pageIndex = lastPageIndex;
        }
        // Start pages are always populated first
        this.startPages = Array.from({ length: this.startPageCount }, (v, i) => i).filter(maxPageIndexFilter);
        // If there aren't enough pages to start the middle pages, just set the other arrays to empty
        if (lastPageIndex < this.startPageCount) {
            this.middlePages = [];
            this.endPages = [];
            return;
        }
        // Adjust start index by half the middle page count to put the active page in the middle
        const simpleStartIndex = this.pageIndex - Math.floor(this.middlePageCount / 2);
        const startOfMiddleNumbers = Math.max(
        // Middle numbers must always start after the start numbers
        this.startPageCount, 
        // Middle numbers must always end before the end numbers
        Math.min(simpleStartIndex, lastPageIndex - this.middlePageCount));
        this.middlePages = Array.from({ length: this.middlePageCount }, (v, i) => startOfMiddleNumbers + i).filter(maxPageIndexFilter);
        // If there aren't enough pages to fill up the middle section, just set the last section to empty list
        if (lastPageIndex < this.startPageCount + this.middlePageCount) {
            this.endPages = [];
            return;
        }
        this.endPages = Array.from({ length: this.endPageCount }, (v, i) => lastPageIndex - i)
            .filter(maxPageIndexFilter)
            .reverse();
    }
    goToPage(page) {
        if (page === this.pageIndex) {
            return;
        }
        if (this.getNumberOfPages() < page) {
            this.pageIndex = this.getNumberOfPages();
            this.updatePageNumbers();
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex = page;
        this.updatePageNumbers();
        this.emitPageEvent(previousPageIndex);
        this.announcePage(page);
    }
    announcePage(page) {
        const ofText = this.translateService.translate('ngx-shared-of').pipe(take(1));
        const pageChanged = this.translateService.translate('ngx-shared-page-changed').pipe(take(1));
        const to = this.translateService.translate('ngx-shared-to').pipe(take(1));
        const showing = this.translateService.translate('ngx-shared-showing').pipe(take(1));
        forkJoin({ ofText, pageChanged, to, showing })
            .pipe(takeUntil(this.destroy$))
            .subscribe(({ ofText, pageChanged, to, showing }) => {
            const resultsText = this.getResultsText(this.getPageItems(), ofText, to);
            let announcementText = `${pageChanged} ${to} ${Number(page) + 1}`;
            if (resultsText !== '') {
                announcementText = announcementText.concat(` ${showing} ${resultsText}.`);
            }
            this.liveAnnouncer.announce(announcementText);
        });
    }
    nextPage() {
        if (!this.hasNextPage()) {
            return;
        }
        this.goToPage(this.pageIndex + 1);
    }
    previousPage() {
        if (!this.hasPreviousPage()) {
            return;
        }
        this.goToPage(this.pageIndex - 1);
    }
    /** Whether there is a previous page. */
    hasPreviousPage() {
        return this.pageIndex >= 1 && this.pageSize !== 0;
    }
    /** Whether there is a next page. */
    hasNextPage() {
        const maxPageIndex = this.getNumberOfPages() - 1;
        return this.pageIndex < maxPageIndex && this.pageSize !== 0;
    }
    /** Calculate the number of pages */
    getNumberOfPages() {
        if (!this.pageSize) {
            return 1;
        }
        return Math.max(1, Math.ceil(this.length / this.pageSize));
    }
    nextButtonDisabled() {
        return this.disabled || !this.hasNextPage();
    }
    previousButtonDisabled() {
        return this.disabled || !this.hasPreviousPage();
    }
    get firstItemIndex() {
        return this.pageIndex * this.pageSize;
    }
    get lastItemIndex() {
        return Math.min((this.pageIndex + 1) * this.pageSize - 1, this.length - 1);
    }
    getPageItems() {
        return {
            first: this.firstItemIndex + 1,
            last: this.lastItemIndex + 1,
            count: this.length > 0 ? this.lastItemIndex - this.firstItemIndex + 1 : 0,
            total: this.length,
        };
    }
    getResultsText(pageItems, ofTranslation, toTranslation) {
        if (pageItems.count === 0) {
            return '';
        }
        if (pageItems.count === 1) {
            return `${pageItems.first} ${ofTranslation} ${pageItems.total}`;
        }
        if (pageItems.count > 1) {
            return `${pageItems.first} ${toTranslation} ${pageItems.last} ${ofTranslation} ${pageItems.total}`;
        }
        return '';
    }
    /** Emits an event notifying that a change of the paginator's properties has been triggered. */
    emitPageEvent(previousPageIndex) {
        this.page.emit({
            previousPageIndex,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            length: this.length,
            firstItemIndex: this.firstItemIndex,
            lastItemIndex: this.lastItemIndex,
        });
    }
}
PagerComponent.ɵfac = function PagerComponent_Factory(t) { return new (t || PagerComponent)(i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(i2.LiveAnnouncer), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef)); };
PagerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PagerComponent, selectors: [["mhe-pager"]], contentQueries: function PagerComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, _c0, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pagerMessage = _t.first);
    } }, inputs: { disabled: "disabled", pageIndex: "pageIndex", length: "length", pageSize: "pageSize" }, outputs: { page: "page" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 7, consts: function () { let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_8115913386581278432$$NGX_SHARED_PAGER_PAGER_COMPONENT_TS___3 = goog.getMsg(" {$interpolation} {$interpolation_1} {$interpolation_2} ", { "interpolation": "\uFFFD0\uFFFD", "interpolation_1": "\uFFFD1\uFFFD", "interpolation_2": "\uFFFD2\uFFFD" }, { original_code: { "interpolation": "{{ pageItems.first }}", "interpolation_1": "{{ 'ngx-shared-of' | mheTranslate | async }}", "interpolation_2": "{{ pageItems.total }}" } });
        i18n_2 = MSG_EXTERNAL_8115913386581278432$$NGX_SHARED_PAGER_PAGER_COMPONENT_TS___3;
    }
    else {
        i18n_2 = $localize `:␟e0a679d961f16926b60c028a0655e1c3a37873a3␟8115913386581278432: ${"\uFFFD0\uFFFD"}:INTERPOLATION: ${"\uFFFD1\uFFFD"}:INTERPOLATION_1: ${"\uFFFD2\uFFFD"}:INTERPOLATION_2: `;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @suppress {msgDescriptions}
         */
        const MSG_EXTERNAL_6354179413563968020$$NGX_SHARED_PAGER_PAGER_COMPONENT_TS___5 = goog.getMsg(" {$interpolation}{$startTagSpan}{$interpolation_1}{$closeTagSpan}{$startTagSpan_1}\u2013{$closeTagSpan}{$interpolation_2} {$interpolation_3} {$interpolation_4} ", { "interpolation": "\uFFFD0\uFFFD", "startTagSpan": "\uFFFD#2\uFFFD", "interpolation_1": "\uFFFD1\uFFFD", "closeTagSpan": "[\uFFFD/#2\uFFFD|\uFFFD/#5\uFFFD]", "startTagSpan_1": "\uFFFD#5\uFFFD", "interpolation_2": "\uFFFD2\uFFFD", "interpolation_3": "\uFFFD3\uFFFD", "interpolation_4": "\uFFFD4\uFFFD" }, { original_code: { "interpolation": "{{ pageItems.first }}", "startTagSpan": "<span class=\"sr-only\">", "interpolation_1": "{{ 'ngx-shared-to' | mheTranslate | async }}", "closeTagSpan": "</span>", "startTagSpan_1": "<span aria-hidden=\"true\">", "interpolation_2": "{{ pageItems.last }}", "interpolation_3": "{{ 'ngx-shared-of' | mheTranslate | async }}", "interpolation_4": "{{ pageItems.total }}" } });
        i18n_4 = MSG_EXTERNAL_6354179413563968020$$NGX_SHARED_PAGER_PAGER_COMPONENT_TS___5;
    }
    else {
        i18n_4 = $localize `:␟52bd8735c4783d9a8aaaa4b1288c6b8d742a7563␟6354179413563968020: ${"\uFFFD0\uFFFD"}:INTERPOLATION:${"\uFFFD#2\uFFFD"}:START_TAG_SPAN:${"\uFFFD1\uFFFD"}:INTERPOLATION_1:${"[\uFFFD/#2\uFFFD|\uFFFD/#5\uFFFD]"}:CLOSE_TAG_SPAN:${"\uFFFD#5\uFFFD"}:START_TAG_SPAN_1:–${"[\uFFFD/#2\uFFFD|\uFFFD/#5\uFFFD]"}:CLOSE_TAG_SPAN:${"\uFFFD2\uFFFD"}:INTERPOLATION_2: ${"\uFFFD3\uFFFD"}:INTERPOLATION_3: ${"\uFFFD4\uFFFD"}:INTERPOLATION_4: `;
    } i18n_4 = i0.ɵɵi18nPostprocess(i18n_4); return [[4, "ngIf"], [1, "small", 3, "ngStyle"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["button", ""], ["defaultMessage", ""], [1, "btn-group", "btn-group-sm"], ["mheTooltip", "Previous Page", 1, "btn", "btn-light", "pager-left", 3, "disabled", "click"], [1, "dpg-icon", "dpg-icon-dropdown-arrow-left"], [4, "ngFor", "ngForOf"], ["class", "btn btn-light", "disabled", "", 4, "ngIf"], ["mheTooltip", "Next Page", 1, "btn", "btn-light", "pager-right", 3, "disabled", "click"], [1, "dpg-icon", "dpg-icon-dropdown-arrow-right"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["disabled", "", 1, "btn", "btn-light"], [1, "btn", 3, "disabled", "click"], [1, "sr-only"], i18n_2, i18n_4, ["aria-hidden", "true"]]; }, template: function PagerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PagerComponent_ng_container_0_Template, 11, 7, "ng-container", 0);
        i0.ɵɵelementStart(1, "span", 1);
        i0.ɵɵelementContainer(2, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, PagerComponent_ng_template_3_Template, 6, 12, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, PagerComponent_ng_template_5_Template, 3, 3, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(6);
        i0.ɵɵproperty("ngIf", ctx.getNumberOfPages() > 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(4, _c6));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.pagerMessage || _r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c1, ctx.getPageItems()));
    } }, dependencies: [i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i3.NgStyle, i4.TooltipDirective, i3.AsyncPipe, i1.TranslatePipe], styles: ["[_nghost-%COMP%]{display:inline-block;flex-grow:0;flex-shrink:0;justify-content:center;word-spacing:-100%}\n"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PagerComponent, [{
        type: Component,
        args: [{ selector: 'mhe-pager', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"getNumberOfPages() > 1\">\n  <div class=\"btn-group btn-group-sm\">\n    <button\n      mheTooltip=\"Previous Page\"\n      class=\"btn btn-light pager-left\"\n      [disabled]=\"previousButtonDisabled()\"\n      (click)=\"previousPage()\"\n    >\n      <i class=\"dpg-icon dpg-icon-dropdown-arrow-left\"> </i>\n    </button>\n\n    <ng-container *ngFor=\"let page of getStartPages()\">\n      <ng-container *ngTemplateOutlet=\"button; context: { $implicit: page }\"></ng-container>\n    </ng-container>\n\n    <button\n      class=\"btn btn-light\"\n      disabled\n      *ngIf=\"shouldShowFirstElipsis()\"\n      [attr.aria-label]=\"'ngx-shared-pager-ellipsis' | mheTranslate | async\"\n    >\n      &#x22ef;\n    </button>\n\n    <ng-container *ngFor=\"let page of getMiddlePages()\">\n      <ng-container *ngTemplateOutlet=\"button; context: { $implicit: page }\"></ng-container>\n    </ng-container>\n\n    <button\n      class=\"btn btn-light\"\n      disabled\n      *ngIf=\"shouldShowLastElipsis()\"\n      [attr.aria-label]=\"'ngx-shared-pager-ellipsis' | mheTranslate | async\"\n    >\n      &#x22ef;\n    </button>\n\n    <ng-container *ngFor=\"let page of getEndPages()\">\n      <ng-container *ngTemplateOutlet=\"button; context: { $implicit: page }\"></ng-container>\n    </ng-container>\n\n    <button\n      mheTooltip=\"Next Page\"\n      class=\"btn btn-light pager-right\"\n      [disabled]=\"nextButtonDisabled()\"\n      (click)=\"nextPage()\"\n    >\n      <i class=\"dpg-icon dpg-icon-dropdown-arrow-right\"> </i>\n    </button>\n  </div>\n</ng-container>\n\n<span class=\"small\" [ngStyle]=\"{ 'word-spacing': 'normal' }\">\n  <ng-container\n    [ngTemplateOutlet]=\"pagerMessage || defaultMessage\"\n    [ngTemplateOutletContext]=\"{ $implicit: getPageItems() }\"\n  ></ng-container>\n</span>\n\n<ng-template #button let-page>\n  <button\n    class=\"btn\"\n    [class.btn-light]=\"pageIndex !== page\"\n    [class.btn-primary]=\"pageIndex === page\"\n    [attr.aria-current]=\"pageIndex === page\"\n    [disabled]=\"disabled\"\n    (click)=\"goToPage(page)\"\n  >\n    <span class=\"sr-only\">{{ 'ngx-shared-page' | mheTranslate | async }}</span>\n    {{ page + 1 }}\n  </button>\n</ng-template>\n\n<ng-template #defaultMessage let-pageItems>\n  <span *ngIf=\"pageItems.count === 0\" i18n></span>\n  <span *ngIf=\"pageItems.count === 1\" i18n>\n    {{ pageItems.first }} {{ 'ngx-shared-of' | mheTranslate | async }} {{ pageItems.total }}\n  </span>\n  <span *ngIf=\"pageItems.count > 1\" i18n>\n    {{ pageItems.first }}<span class=\"sr-only\">{{ 'ngx-shared-to' | mheTranslate | async }}</span\n    ><span aria-hidden=\"true\">&ndash;</span>{{ pageItems.last }} {{ 'ngx-shared-of' | mheTranslate | async }}\n    {{ pageItems.total }}\n  </span>\n</ng-template>\n", styles: [":host{display:inline-block;flex-grow:0;flex-shrink:0;justify-content:center;word-spacing:-100%}/*# sourceMappingURL=pager.component.css.map */\n"] }]
    }], function () { return [{ type: i1.TranslateService }, { type: i2.LiveAnnouncer }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; }, { pagerMessage: [{
            type: ContentChild,
            args: ['pagerMessage', { static: true }]
        }], disabled: [{
            type: Input
        }], pageIndex: [{
            type: Input
        }], length: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], page: [{
            type: Output
        }] }); })();
